<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'main.nav.links.account.fullLabel' | translate}}
                <app-tooltip text="{{'main.nav.links.account.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p>Work in progress…</p>
    </mat-card-content>
</mat-card>
